import LandingHero from "@/components/landing/LandingHero";
import LandingHowItWorks from "@/components/landing/LandingHowItWorks";
import LandingCallDetails from "@/components/landing/LandingCallDetails";
import LandingProofStrip from "@/components/landing/LandingProofStrip";
import LandingAuthority from "@/components/landing/LandingAuthority";
import GrowthAnalysisForm from "@/components/landing/GrowthAnalysisForm";
import LandingCta from "@/components/landing/LandingCta";
import Footer from "@/components/Footer";

const ApplyPage = () => {
  return (
    <div className="min-h-screen">
      <LandingHero />
      <LandingHowItWorks />
      <LandingCallDetails />
      <LandingProofStrip />
      <LandingAuthority />
      <GrowthAnalysisForm />
      <LandingCta />
      <Footer />
    </div>
  );
};

export default ApplyPage;
